// Mounts the HUD into #hud and returns the hooks the app loop and other jobs use.
import { signal } from '@preact/signals';
import { h, render } from 'preact';
import type { RaceEvent, RaceSnapshot } from '../race/types';
import { Hud } from './Hud';
import type { TagSource } from './NameTags';
import { HudStore, type SourceInfo } from './store';
import './hud.css';

export interface HudOptions {
  /** Called when the viewer presses Start (the gesture that may enable sound). */
  onStart: () => void;
  /** Screen positions for name tags, published by the world each frame. */
  tagPositions?: TagSource;
  /** Picks among the original caption lines; seeded with ?seed. */
  rand?: () => number;
}

export interface HudHandle {
  store: HudStore;
  update(snapshot: RaceSnapshot, events: RaceEvent[], nowMs: number, source: SourceInfo): void;
  setTagSource(fn: TagSource): void;
  /** Skip the title screen (autostart). */
  start(): void;
}

export function mountHud(el: HTMLElement, opts: HudOptions): HudHandle {
  const store = new HudStore(opts.rand);
  const tags = signal<ReturnType<TagSource>>([]);
  let tagSource = opts.tagPositions;
  let lastTags = 0;
  const start = () => { if (store.started.value) return; store.started.value = true; opts.onStart(); };
  render(h(Hud, { store, onStart: start, tags }), el);
  return {
    store,
    update(snapshot, events, nowMs, source) {
      store.update(snapshot, events, nowMs, source);
      if (tagSource && store.started.value && nowMs - lastTags > 33) { tags.value = tagSource(); lastTags = nowMs; }
    },
    setTagSource(fn) { tagSource = fn; },
    start() { store.started.value = true; },
  };
}
